import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/contexts/AuthContext';
import { useSubscription } from '@/features/subscription/hooks/useSubscription';
import { PlanCards } from '@/features/subscription/components/PlanCards';
import { LogOut } from 'lucide-react';

const TrialExpired = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const { tier, loading, startCheckout, manageSubscription } = useSubscription();

  useEffect(() => {
    if (!loading && tier !== 'free') navigate('/', { replace: true });
  }, [tier, loading, navigate]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-start px-4 pt-16 pb-24 space-y-8">

      <div className="text-center space-y-3 max-w-sm">
        <div className="text-5xl">⏰</div>
        <h1 className="text-2xl font-bold font-display">Votre essai est terminé</h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Choisissez un plan pour continuer à utiliser Consentink et accéder à toutes vos données.
        </p>
      </div>

      <div className="w-full max-w-2xl">
        <PlanCards
          showToggle
          tier={tier}
          isLegacyFree={false}
          trialAvailable={false}
          startCheckout={startCheckout}
          manageSubscription={manageSubscription}
        />
      </div>

      <button
        onClick={() => signOut()}
        className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
      >
        <LogOut size={16} />
        Se déconnecter
      </button>

    </div>
  );
};

export default TrialExpired;
